import React, { useState } from "react";
import classes from "./Loader.module.css";
import logo from "../../assets/logo/black.png";
import { useSpring, animated } from "react-spring";
import { motion } from "framer-motion";

const animateFrom = { opacity: 0 };
const animateTo = { opacity: 1 };

const Loader = () => {
  const [flip, set] = useState(false);
  const { x } = useSpring({
    reset: true,
    reverse: flip,
    from: { x: 0 },
    x: 1,
    delay: 200,
    config: { mass: 1, tension: 280, friction: 120 },
    onRest: () => set(!flip),
  });

  return (
    <div className={classes.loader}>
      <animated.svg
        className={classes.loader__logo}
        xmlnsXlink="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#f06868"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray={70}
        strokeDashoffset={x.to((x) => (1 - x) * 70)}
      >
        <defs>
          <circle id="circle" cx="12" cy="12" r="10"></circle>
          <clipPath id="circle-clip">
            <use xlinkHref="#circle" />
          </clipPath>
        </defs>
        <g clipPath="url(#circle-clip)">
          <motion.image
            xlinkHref={logo}
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid slice"
            initial={animateFrom}
            animate={animateTo}
            transition={{ delay: 1.1, duration: 1.2, type: "tween" }}
          />
          <use
            xlinkHref="#circle"
            fill="none"
            stroke="#f06868"
            strokeWidth="5.8"
            opacity=".9"
          />
        </g>
      </animated.svg>
    </div>
  );
};

export default Loader;
